class aLanguageSwitcher extends HTMLSelectElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.addEventListener('change', this.onChange);
    }

    disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
    }

    onChange(e) {
        var newLocale = null;

        if (e && e.currentTarget && e.currentTarget.value) { // standard <select> (mobile)
            if (e.currentTarget.value !== '#') {
                newLocale = e.currentTarget.value;
            }
        } else if (e && e.detail && e.detail.value) { // custom select (desktop)
            if (e.detail.value !== '#') {
                newLocale = e.detail.value;
            }
        }

        if (newLocale) {
            // This lookup the hreflangs url
            var currentPageAlternateUrl = document.head.querySelector('link[rel="alternate"][hreflang="' + newLocale + '"]');

            if (currentPageAlternateUrl) {
                window.location.href = currentPageAlternateUrl.href;
            }
        }
    }
}

customElements.define('a-language-switcher', aLanguageSwitcher, {
    extends: 'select'
});
